<template>
  <div class="academic-year-form-container">
    <div class="page-header">
      <div class="breadcrumb">ວິຊາການ / ສົກຮຽນ / <span>{{ isEdit ? 'ແກ້ໄຂສົກຮຽນ' : 'ເພີ່ມສົກຮຽນໃໝ່' }}</span></div>
      <div class="header-content">
        <h1>{{ isEdit ? 'ແກ້ໄຂຂໍ້ມູນສົກຮຽນ' : 'ເພີ່ມສົກຮຽນໃໝ່' }}</h1>
      </div>
    </div>

    <div class="panel shadow-sm" style="max-width: 600px;">
      <div class="panel-body">
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label>ລະຫັດສົກຮຽນ (ID) <span class="req">*</span></label>
            <input type="text" v-model="form.id" placeholder="ຕົວຢ່າງ: 2025" required>
          </div>
          <div class="form-group">
            <label>ຊື່ສົກຮຽນ <span class="req">*</span></label>
            <input type="text" v-model="form.accd" placeholder="ຕົວຢ່າງ: 2025-2026" required>
          </div>
          
          <div class="form-actions-wrapper mt-4 pt-3 border-top">
            <button type="button" class="btn-cancel" @click="$router.back()">ຍົກເລີກ</button>
            <button type="submit" class="btn-save" :disabled="submitting">
              <i class="fas fa-save"></i> {{ submitting ? 'ກຳລັງບັນທຶກ...' : 'ບັນທຶກຂໍ້ມູນ' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api';

export default {
  name: 'AcademicYearFormPage',
  data() {
    return {
      isEdit: false,
      submitting: false,
      form: { id: '', accd: '' }
    };
  },
  async mounted() {
    const id = this.$route.params.id;
    if (id) { this.isEdit = true; this.fetchData(id); }
  },
  methods: {
    async fetchData(mongoId) {
      try {
        const res = await api.get(`/get/accd/${mongoId}`);
        if (res.data.code === 1) this.form = res.data.rows;
      } catch (e) { console.error(e); }
    },
    async handleSubmit() {
      this.submitting = true;
      try {
        let res;
        if (this.isEdit) {
          res = await api.put(`/update/accd/${this.$route.params.id}`, { items: this.form });
        } else {
          res = await api.post('/insertOne', { items: this.form, table: 'accd' });
        }

        if (res.data.code === 1) {
          alert('ບັນທຶກສົກຮຽນສຳເລັດ');
          this.$router.push('/home/academic/year/list');
        }
      } catch (e) { alert('ເກີດຂໍ້ຜິດພາດໃນການເຊື່ອມຕໍ່'); }
      finally { this.submitting = false; }
    }
  }
};
</script>

<style scoped>
.academic-year-form-container { animation: fadeIn 0.3s ease; }
.form-group { margin-bottom: 20px; }
.form-group label { display: block; font-size: 13px; color: var(--text2); margin-bottom: 8px; font-weight: 600; }
.form-group input { width: 100%; padding: 10px; border: 1px solid var(--border); border-radius: 8px; font-size: 14px; }
.req { color: var(--danger); }
.form-actions-wrapper { display: flex; justify-content: flex-end; gap: 12px; }
.btn-save { background: var(--lao); color: white; border: none; padding: 10px 25px; border-radius: 8px; cursor: pointer; font-weight: 600; }
.btn-cancel { background: #e2e8f0; color: var(--text2); border: none; padding: 10px 20px; border-radius: 8px; cursor: pointer; }
.border-top { border-top: 1px solid var(--border); }
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>